import styled from 'styled-components';

export const User = styled.div`
  background: white;
  min-height: 100%;
`
